import metropolisMediumUrl from '@stamhoofd/assets/fonts/Metropolis/WOFF2/Metropolis-Medium.woff2';
import metropolisBoldUrl from '@stamhoofd/assets/fonts/Metropolis/WOFF2/Metropolis-SemiBold.woff2';
import type { PdfFont } from './PdfFont';

export const metropolisMedium: PdfFont = {
    name: 'metropolisMedium',
    url: metropolisMediumUrl,
};

export const metropolisBold: PdfFont = {
    name: 'metropolisBold',
    url: metropolisBoldUrl,
};
